import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import pathConstant from "../../../utils/path.constant";
import logo from './../../../assets/image/logo.jpg';
import React, { ChangeEvent, useState, MouseEvent } from "react";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";
import { api } from "../../../services/apis/auth-api/apiUrl";
import { LOGIN_END_POINT } from "../../../config/config";
import { AxiosError } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const SignIn : React.FC = ()=>{

    const { setIsAuthenticated, setJWTData } = useAuth() as AuthContextState;
    const navigate = useNavigate();

    const [logInCredentials, setLogInCredentials] = useState({email : '', password : ''});
    const [loginStatus, setLoginStatus] = useState('');
    const [isLoading, setLoading] = useState<boolean>(false);

    const updateCredentialsState = (e : ChangeEvent<HTMLInputElement>) =>{
        const {name, value} = e.target;

        setLogInCredentials({
            ...logInCredentials,
            [name] : value
        })
    }

    const useLogin = (e : MouseEvent<HTMLButtonElement>) =>{
        e.preventDefault();
        setLoading(true);
        setTimeout(async()=>{
            const credIsNotComplete = Object.values(logInCredentials).some(value => value === '');
            if(credIsNotComplete) { setLoading(false); return setLoginStatus('Email or password is required.'); }
    
            try{
                const logInResponse = await api.post(LOGIN_END_POINT, logInCredentials);
                localStorage.setItem('token', logInResponse.data.token);
                localStorage.setItem('auth_session_exp', logInResponse.data.exp);
    
                const jwtDecoded = await setJWTData();
    
                if(!jwtDecoded) {
                    setLoading(false);
                    return setLoginStatus('Failed to fetch account. Please try again.');
                }
                setIsAuthenticated(true);
                const lastProtectRoute = localStorage.getItem('lastProtectedRouted');
                navigate(lastProtectRoute ? lastProtectRoute : pathConstant.DASHBOARD);
            }catch(e){
                const error = (e as AxiosError);
                setLoading(false);
                setLogInCredentials({
                    ...logInCredentials,
                    password : ''
                })
                if(error.response?.status === 401) return setLoginStatus('Email or password is incorrect.');
                setLoginStatus('Something went wrong. Please try again.')
            }
        },500)
    }

    return (
        <div className='main-container'>
            <Helmet>
                <title>Sign in</title>
            </Helmet>
            <div className='auth-card'>
                <div className='flex justify-center'>
                    <img src={logo} alt="VCCL_Logo" className='logo' />
                </div>
                <div className='card-header'>
                    Sign in
                </div>
                <div className='text-red-500'>
                    {loginStatus}
                </div>
                <div className='card-body'>
                    <form>
                        <div className='input-container'>
                            <input type="text" name="email" onChange={updateCredentialsState} className='text-box' value={logInCredentials.email} placeholder="Email" />
                        </div>
                        <div className='input-container'>
                            <input type="password" name="password" onChange={updateCredentialsState} className='text-box' value={logInCredentials.password} placeholder="Password" />
                        </div>
                        <div className='input-container'>
                            {isLoading ? (
                                <button type="button" disabled className='button button-disabled'>
                                   <FontAwesomeIcon className='animate-spin' icon={faSpinner} /> Signing in....
                                </button>
                            ) : (
                                <button type="button" onClick={useLogin} className='button button-vcc-primary'>Sign in</button>
                            )}
                        </div>
                    </form>
                </div>
                <div className='card-footer'>
                    <Link to={pathConstant.FORGOT_PASSWORD}>Forgot password?</Link>
                </div>
            </div>
        </div>
    );
}

export default SignIn;